export default {
  tagSettingsTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  tagSettingsTitle: { flex: 1 },
  tagSettingsActionsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  addButton: { color: 'white' },
};
